// import React, { useState } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faFilePdf,
//   faFilePowerpoint,
//   faCloud,
// } from "@fortawesome/free-solid-svg-icons"; // Use only solid icons
// import AzureLogo from "../assets/AI images/Azure.png";
// import AWSLogo from "../assets/AI images/aws.png";
// import gcp from "../assets/AI images/gcp.png";
// import { Button, Toast, ToastContainer } from "react-bootstrap";

// const QuickLinks = () => {
//   const [showToast, setShowToast] = useState(false);
//   // URL for the PDF file
//   const pdfUrl =
//     "https://blobtimesheet.blob.core.windows.net/llminsight-docs/LLMInsight_Deck.pdf";

//   // Blob URL for the PPT File
//   const pptBlobUrl =
//     "https://blobtimesheet.blob.core.windows.net/llminsight-docs/One_pager-LLMInsight.pptx";

//   const azureUrl =
//     "https://azuremarketplace.microsoft.com/en-us/marketplace/apps/shrisaitechllc1657565263846.constingapp?tab=Overview";

//   const googleUrl = "";
//   const awsUrl = "";

//   const handleAzureClick = () => {
//     window.open(azureUrl, "_blank");
//   };

//   const handleToastClose = () => {
//     setShowToast(false); // Hide the toast when closed
//   };

//   const handleGoogleClick = () => {
//     setShowToast(true);
//   };

//   const handleAwsClick = () => {
//     setShowToast(true);
//   };

//   // Handle PDF card click
//   const handlePdfClick = async () => {
//     // window.open(pdfUrl, "_blank");
//     try {
//       // Test if the URL is accessible
//       const response = await fetch(pdfUrl, { method: "HEAD" });
//       if (response.ok) {
//         window.open(pdfUrl, "_blank");
//       } else {
//         console.error("PDF not found or inaccessible");
//         alert("Sorry, the PDF could not be opened.");
//       }
//     } catch (error) {
//       console.error("Error checking PDF:", error);
//       alert("An error occurred while trying to access the PDF.");
//     }
//   };

//   // Function to download the PPT file
//   const handleDownloadPpt = () => {
//     fetch(pptBlobUrl)
//       .then((response) => response.blob())
//       .then((blob) => {
//         const url = window.URL.createObjectURL(blob);
//         const a = document.createElement("a");
//         a.href = url;
//         a.download = "one_pager.ppt"; // Desired download file name
//         document.body.appendChild(a);
//         a.click();
//         document.body.removeChild(a);
//         window.URL.revokeObjectURL(url);
//       })
//       .catch((error) => console.error("Error downloading PPT file:", error));
//   };

//   return (
//     <div className="container">
//       <h2 className="text-center my-4">Quick Links</h2>
//       <div className="row">
//         {/* PDF Card */}
//         <div className="col-12 col-sm-12 col-md-4 mb-4">
//           <div
//             className="card text-center"
//             onClick={handlePdfClick}
//             style={{
//               cursor: "pointer",
//               boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
//               transition: "0.3s",
//               borderRadius: "8px",
//               maxWidth: "100%", // Ensures responsiveness
//               height: "auto", // Allows content to define height
//               padding: "1rem", // Adds better spacing
//             }}
//           >
//             <div className="card-body">
//               <FontAwesomeIcon
//                 icon={faFilePdf}
//                 style={{
//                   fontSize: "clamp(30px, 2vw, 40px)", // Responsive icon size
//                   color: "#D32F2F",
//                 }}
//               />
//               <h5
//                 className="card-title mt-3"
//                 style={{
//                   fontSize: "clamp(14px, 1.2vw, 18px)", // Responsive font size
//                   marginBottom: "10px",
//                 }}
//               >
//                 LLM Insight Deck
//               </h5>
//             </div>
//           </div>
//         </div>

//         {/* PPT Card */}
//         <div className="col-12 col-md-4 mb-4">
//           <div
//             className="card text-center"
//             onClick={handleDownloadPpt}
//             style={{
//               cursor: "pointer",
//               boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
//               transition: "0.3s",
//               borderRadius: "8px",
//               height: "auto", // Allow content to define height
//             }}
//           >
//             <div className="card-body">
//               <FontAwesomeIcon
//                 icon={faFilePowerpoint}
//                 style={{ fontSize: "40px", color: "#388E3C" }}
//               />
//               <h5 className="card-title mt-3" style={{ fontSize: 16 }}>
//                 Download One Pager
//               </h5>
//             </div>
//           </div>
//         </div>

//         {/* Azure link */}
//         <div className="col-12 col-md-4 mb-4">
//           <div
//             className="card text-center d-flex flex-column justify-content-center align-items-center"
//             onClick={handleAzureClick}
//             style={{
//               cursor: "pointer",
//               boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
//               transition: "0.3s",
//               borderRadius: "8px",
//               height: "auto", // Allow content to define height
//               padding: "10px",
//             }}
//           >
//             <div className="card-body d-flex flex-column align-items-center">
//               <img
//                 src={AzureLogo}
//                 alt="Azure Logo"
//                 style={{
//                   maxWidth: "50px", // Ensure it doesn't overflow
//                   height: "auto",
//                   opacity: 0.8,
//                   objectFit: "contain",
//                 }}
//               />
//               <h6
//                 className="card-title mt-2 text-wrap text-center"
//                 style={{ fontSize: "14px", wordWrap: "break-word" }}
//               >
//                 Download From Azure Marketplace
//               </h6>
//             </div>
//           </div>
//         </div>

//         {/* Aws link */}
//         <div className="col-12 col-md-4 mb-4">
//           <div
//             className="card text-center"
//             onClick={handleAwsClick}
//             style={{
//               cursor: "pointer",
//               boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
//               transition: "0.3s",
//               borderRadius: "8px",
//               height: "auto", // Allow content to define height
//             }}
//           >
//             <div
//               className="card-body"
//               style={{ justifyContent: "center", alignItems: "center" }}
//             >
//               <img
//                 src={AWSLogo}
//                 alt="AWS Logo"
//                 style={{
//                   maxWidth: "100%",
//                   width: 60,
//                   height: "auto",
//                   opacity: 0.8,
//                   objectFit: "contain",
//                 }}
//               />
//               {/* <FontAwesomeIcon
//                 icon={faCloud} // Using the cloud icon for Azure
//                 style={{
//                   fontSize: "40px",
//                   color: "#0078D4", // Azure color
//                 }}
//               /> */}
//               <h6 className="card-title mt-3" style={{ fontSize: 16 }}>
//                 Get From AWS Cloud
//               </h6>
//             </div>
//           </div>
//         </div>
//         {/* Google link */}
//         <div className="col-12 col-md-4 mb-4">
//           <div
//             className="card text-center"
//             onClick={handleGoogleClick}
//             style={{
//               cursor: "pointer",
//               boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
//               transition: "0.3s",
//               borderRadius: "8px",
//               height: "auto", // Allow content to define height
//             }}
//           >
//             <div className="card-body">
//               <img
//                 src={gcp}
//                 alt="GCP Logo"
//                 style={{
//                   maxWidth: "100%",
//                   width: 60,
//                   height: "auto",
//                   opacity: 0.8,
//                   objectFit: "contain",
//                 }}
//               />
//               <h5 className="card-title mt-3" style={{ fontSize: 16 }}>
//                 Get From Google Cloud
//               </h5>
//             </div>
//           </div>
//         </div>
//       </div>
//       {/* Toast Container and Toast */}
//       <ToastContainer position="top-end" className="p-3">
//         <Toast
//           onClose={handleToastClose}
//           show={showToast}
//           delay={3000} // Auto-hide after 3 seconds
//           autohide
//         >
//           <Toast.Header>
//             <strong className="me-auto">Notification</strong>
//           </Toast.Header>
//           <Toast.Body>This feature is under development</Toast.Body>
//         </Toast>
//       </ToastContainer>
//     </div>
//   );
// };

// export default QuickLinks;

import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf, faFilePowerpoint } from "@fortawesome/free-solid-svg-icons";
import AzureLogo from "../assets/AI images/Azure.png";
import AWSLogo from "../assets/AI images/aws.png";
import vertexImage from "../assets/AI images/vertex.png";
import gcp from "../assets/AI images/gcp.png";
import { Toast, ToastContainer } from "react-bootstrap";

const QuickLinks = () => {
  const [showToast, setShowToast] = useState(false);
  const pdfUrl =
    "https://stllminsightdev.blob.core.windows.net/llminsightfiles/LLMInsight_Google_VertextAI_.pdf";
  // "https://blobtimesheet.blob.core.windows.net/llminsight-docs/LLMInsightAI_deck.pdf";
  const vertexUrl =
    "https://stllminsightdev.blob.core.windows.net/llminsightfiles/LLMInsight_Google_VertextAI_new_.pdf";
  const pptBlobUrl =
    "https://blobtimesheet.blob.core.windows.net/llminsight-docs/OnePager-LLMInsight.pdf";
  const azureUrl =
    "https://azuremarketplace.microsoft.com/en-us/marketplace/apps/shrisaitechllc1657565263846.constingapp?tab=Overview";

  const handleAzureClick = () => window.open(azureUrl, "_blank");
  const handleToastClose = () => setShowToast(false);
  const handleGoogleClick = () => setShowToast(true);
  const handleAwsClick = () => setShowToast(true);

  const handlePdfClick = async (url) => {
    try {
      const response = await fetch(url, { method: "HEAD" });
      if (response.ok) {
        window.open(url, "_blank");
      } else {
        alert("Sorry, the PDF could not be opened.");
      }
    } catch {
      alert("An error occurred while trying to access the PDF.");
    }
  };

  const handleDownloadPpt = () => {
    fetch(pptBlobUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "one_pager.ppt";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch(() => alert("Error downloading PPT file."));
  };

  const cardData = [
    {
      icon: faFilePdf,
      color: "#D32F2F",
      title: "LLM Insight Deck",
      onClick: () => handlePdfClick(pdfUrl),
    },
    {
      img: vertexImage,
      color: "#D32F2F",
      title: "Vertex AI Deck",
      onClick: () => handlePdfClick(vertexUrl),
    },
    {
      icon: faFilePowerpoint,
      color: "#388E3C",
      title: "Download One Pager",
      onClick: () => handlePdfClick(pptBlobUrl),
    },
    {
      img: AzureLogo,
      title: "Download From Azure Marketplace",
      onClick: handleAzureClick,
    },
    { img: AWSLogo, title: "Get From AWS Cloud", onClick: handleAwsClick },
    { img: gcp, title: "Get From Google Cloud", onClick: handleGoogleClick },
  ];

  return (
    <div className="container">
      <h2 className="text-center my-4">Quick Links</h2>
      <div className="row">
        {cardData.map((card, index) => (
          <div key={index} className="col-12 col-sm-12 col-md-6 col-lg-4 mb-4">
            <div
              className="card text-center d-flex flex-column justify-content-center align-items-center p-1"
              style={{
                cursor: "pointer",
                boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                borderRadius: "8px",
                height: "100%",
              }}
              onClick={card.onClick}
            >
              <div className="card-body">
                {card.icon ? (
                  <FontAwesomeIcon
                    icon={card.icon}
                    style={{ fontSize: "40px", color: card.color }}
                  />
                ) : (
                  <img
                    src={card.img}
                    alt={card.title}
                    style={{ maxWidth: "50px", height: "auto", opacity: 0.8 }}
                  />
                )}
                <h6
                  className="card-title mt-3"
                  style={{ fontSize: "14px", textAlign: "center" }}
                >
                  {card.title}
                </h6>
              </div>
            </div>
          </div>
        ))}
      </div>

      <ToastContainer position="top-end" className="p-3">
        <Toast
          onClose={handleToastClose}
          show={showToast}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body>This feature is under development</Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
};

export default QuickLinks;
